import Axios from 'axios';
import UrlObjParse from 'url-obj-parse';

const endPoint = process.env.REACT_APP_API_URL;
const apiVersion = process.env.REACT_APP_API_VERSION;
const TOKEN_KEY = process.env.REACT_APP_API_TOKEN_KEY;
const loginPath = process.env.REACT_APP_API_LOGIN_PATH;
const debugMode = 'true' == process.env.REACT_APP_DEBUG_MODE;

const loginBackUrl = `${process.env.REACT_APP_BACK_URL}/api/v1/oauth/token`;
const clientId = process.env.REACT_APP_CLIENT_ID;
const clientSecret = process.env.REACT_APP_CLIENT_SECRET;

const writeLog = (loggable) => {
  if (debugMode /* console.log(loggable) */);
};

//Guardamos el toke
async function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

//leer el token
async function getToken() {
  return localStorage.getItem('TVENDO_WS_TOKEN_IMPERSONATED') || localStorage.getItem(TOKEN_KEY);
}

function getLocalToken() {
  return localStorage.getItem('TVENDO_WS_TOKEN_IMPERSONATED') || localStorage.getItem(TOKEN_KEY);
}

function isImpersonated() {
  if(localStorage.getItem("TVENDO_WS_TOKEN_IMPERSONATED") !== null){
    console.log('impersonando')
    return true;
  }
  return false;
}

//eliminar token de localstorage
async function deleteToken() {
  if(isImpersonated()){
    localStorage.removeItem("TVENDO_WS_TOKEN_IMPERSONATED");
    localStorage.removeItem('user_data_impersonated');
    window.location.href = "/admin/dashboard/";
  }else{
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem('user_data');
  }
}

const wsInit = () => {
  Axios.interceptors.request.use(function (config) {
    const token = getLocalToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  Axios.interceptors.response.use(
    //si la llamada al servidor es exitosa, que pase
    function (response) {
      return response;
    },
    function (error) {
      if (error.response === undefined) {
        throw error;
      }

      if (error.response.status === 401) {
        deleteToken();
        if (error.response.config.url === loginBackUrl) {
          throw error;
        }
        //si nuestro token esta malo, vencido, lo borramos de localstorage

        window.location = "/auth/login"; //manadmos al user a al pantalla de inicio de sesion para que haga login
      } else {
        //si el error es otro
        throw error;
      }
    },
  );
};

/* const http = () => {
  return Axios.create({
    //    baseURL:  `${endPoint}/${apiVersion}` ,
    headers: {
      "Content-type": "application/json"
    }
  });
};

function getCustomUrl(path) {
  const baseUrl = `${endPoint}/${path}`;
  return baseUrl;
} */

function getUrl(entity, id) {
  let baseUrl = `${endPoint}/${apiVersion}/${entity}`;
  if (entity.startsWith('/v')) {
    baseUrl = `${endPoint}${entity}`;
  }
  if (id) return `${baseUrl}/${id}`;
  return baseUrl;
}

function getFindUrl(entity, attrib, value) {
  const baseUrl = getUrl(entity);
  return `${baseUrl}?${attrib}=${value}`;
}

async function wsGetAll(entity, options = undefined) {
  let signal = undefined;
  if (options !== undefined) {
    if ('signal' in options) {
      signal = options.signal;
    }
  }
  try {
    const response = await Axios.get(getUrl(entity), { signal });
    return response.data;
  } catch (error) {
    return catchError(error);
  }
}

async function get(url) {
  return await Axios.get(url);
}

async function wsGet(entity, id, params = undefined) {
  if (params === undefined) params = '';
  else params = `?${UrlObjParse(params)}`;
  try {
    const response = await Axios.get(getUrl(entity, id) + params);
    return response.data;
  } catch (error) {
    return catchError(error);
  }
}

async function wsCreate(entity, data) {
  // save to  endpoint
  try {
    const response = await Axios.post(getUrl(entity), data);
    return response.data;
  } catch (error) {
    return catchError(error);
  }
}

async function wsPost(entity, data = undefined) {
  try {
    const response = await Axios.post(getUrl(entity), data);
    return response.data;
  } catch (error) {
    return catchError(error);
  }
}

async function wsUpdate(entity, id, data = undefined) {
  // update to endpoint
  if (typeof id === 'object') {
    try {
      entity = `${endPoint}/${apiVersion}/${entity}`;
      const response = await Axios.put(entity, id);
      return response.data;
    } catch (error) {
      return catchError(error);
    }
  } else {
    try {
      const response = await Axios.put(getUrl(entity, id), data);
      return response.data;
    } catch (error) {
      return catchError(error);
    }
  }
}

async function wsUpdateMasive(entity, data) {
  // update to endpoint
  try {
    const response = await Axios.put(getUrl(entity), data);
    return response.data;
  } catch (error) {
    return catchError(error);
  }
}

/* async function wsRemove(entity, id) {
  // delete from  endpoint
  try {
    const response = await Axios.delete(getUrl(entity, id));
    return response.data;
  } catch (error) {
    return catchError(error);
  }
} */

async function wsRemove(entity, id) {
  if (typeof id == 'object') {
    try {
      entity = `${endPoint}/${apiVersion}/${entity}`;
      const response = await Axios.delete(entity, {
        data: id,
      });
      return response.data;
    } catch (error) {
      return await catchError(error);
    }
  } else {
    try {
      const response = await Axios.delete(getUrl(entity, id));
      return response.data;
    } catch (error) {
      return await catchError(error);
    }
  }
}

async function wsRemoveAll(entity, id, entity2) {
  // delete from  endpoint
  try {
    const response = await Axios.delete(getUrl(entity, id, entity2));
    return response.data;
  } catch (error) {
    return catchError(error);
  }
}

function wsUrl(entity, attrib = false, value = false) {
  const baseUrl = getUrl(entity);
  // find in  endpoint
  let url;
  if (typeof attrib === 'object') {
    url = `${baseUrl}?`;
    for (let [index, attr] of Object.keys(attrib).entries()) {
      if (index > 0 && attrib[attr] != null) {
        url += '&';
      }
      if (Array.isArray(attrib[attr])) {
        let arr = attrib[attr];
        for (let i = 0; i < arr.length; i++) {
          let val = arr[i];
          if (i === 0) {
            url += `${attr}[]=${val}`;
          } else if (i + 1 === arr.length) {
            url += `&${attr}[]=${val}`;
          } else {
            url += `&${attr}[]=${val}`;
          }
        }
      } else {
        if (!attrib[attr]) continue;
        url += `${attr}=${attrib[attr]}`;
      }
    }
  } else if (Array.isArray(value)) {
    url = baseUrl;
    for (let i = 0; i < value.length; i++) {
      let val = value[i];
      if (i === 0) {
        url += `?${attrib}[]=${val}&`;
      } else if (i + 1 === value.length) {
        url += `${attrib}[]=${val}`;
      } else {
        url += `${attrib}[]=${val}&`;
      }
    }
  } else if (attrib && value) {
    url = getFindUrl(entity, attrib, value);
  } else {
    url = baseUrl;
  }
  return url;
}

async function wsFindBy(entity, attrib, value) {
  const baseUrl = getUrl(entity);

  // find in  endpoint
  try {
    if (attrib === undefined && value === undefined) {
      const response = await Axios.get(baseUrl);
      return response.data;
    }

    let url;
    if (typeof attrib === 'object') {
      url = `${baseUrl}?`;
      for (let [index, attr] of Object.keys(attrib).entries()) {
        if (index > 0) {
          url += '&';
        }
        if (Array.isArray(attrib[attr])) {
          let arr = attrib[attr];
          for (let i = 0; i < arr.length; i++) {
            let val = arr[i];
            /* console.log(val, i); */
            if (i === 0) {
              url += `${attr}[]=${val}&`;
            } else if (i + 1 === arr.length) {
              url += `${attr}[]=${val}`;
            } else {
              url += `${attr}[]=${val}&`;
            }
          }
        } else {
          if (!attrib[attr]) continue;
          url += `${attr}=${attrib[attr]}`;
        }
      }
    } else {
      if (Array.isArray(value)) {
        url = baseUrl;
        for (let i = 0; i < value.length; i++) {
          let val = value[i];
          if (i === 0) {
            url += `?${attrib}[]=${val}&`;
          } else if (i + 1 === value.length) {
            url += `${attrib}[]=${val}`;
          } else {
            url += `${attrib}[]=${val}&`;
          }
        }
      } else {
        url = getFindUrl(entity, attrib, value);
      }
    }

    const response = await Axios.get(url);
    return response.data;
  } catch (error) {
    return await catchError(error);
  }
}

async function getCurrentUser() {

  let impersonated = localStorage.getItem('user_data_impersonated') !== null;
  let userJson = localStorage.getItem('user_data_impersonated') || localStorage.getItem('user_data');
  if(userJson === null){
    const response = await get(`${endPoint}/${apiVersion}/oauth/user/current`);
    response.data.data.timestamp = Date.now();
    localStorage.setItem(impersonated ? 'user_data_impersonated' : 'user_data', JSON.stringify(response.data.data));
    return CheckResponse(response);
  }else{
    // Verificando los permisos cada 5 minutos
    let userData = JSON.parse(userJson);
    let validPermissions = false;
    if('timestamp' in userData){
      if (Date.now() - userData.timestamp > 60000 * 5) {
        validPermissions = false;
      } else {
        validPermissions = true;
      }
    }

    if(validPermissions === false){
      const response = await get(`${endPoint}/${apiVersion}/oauth/user/current`);
      response.data.data.timestamp = Date.now();
      localStorage.setItem(impersonated ? 'user_data_impersonated' : 'user_data', JSON.stringify(response.data.data));
      return CheckResponse(response);
    }

    return {
      success: true,
      data: userData,
      message: 'Satisffactorio!!'
    }
  }
}

const CheckResponse = (response) => {
  let content = { success: false };
  writeLog(response);
  if (!response) {
    throw new Error('Ho hay respuesta del servidor remoto');
  } else if (!response.data) {
    throw new Error('Ho hay contenido en la respuesta del servidor remoto');
  } else if (!response.data.data) {
    content = {
      ...content,
      message: response.data.Error ? response.data.Error : 'La resuesta no es correcta',
    };
    throw new Error(response.data.Error ? response.data.Error : 'La resuesta no es correcta');
  } else {
    const data = response.data.data;
    content = {
      ...content,
      success: true,
      data,
      message: response.data.message ?? 'Satisffactorio!!',
    };
  }
  return content;
};

async function wsLogin(data) {
  if (data.authKey.length > 0) {
    data['2fa_key'] = data.authKey;
  }
  delete data.authKey;
  try {
    const loginResponse = await Axios.post(loginBackUrl, {
      ...data,
      grant_type: 'password',
      client_id: clientId,
      client_secret: clientSecret,
    });
    const loginData = loginResponse.data;
    setToken(loginData.access_token);
    wsInit();
    return await getCurrentUser();
  } catch (error) {
    if (error?.response?.data !== null) {
      if (error?.response?.data['2fa_error'] === true) {
        return {
          '2fa_error': true,
        };
      }
    }
    throw error;
  }
}

async function wsImpersonate(user){
  let res = await wsPost('oauth/impersonate', {
    oauth_user_id: user.id,
  })
  if(res.success){
    let accessToken = res.data.access_token;
    let user = res.data.user;

    localStorage.setItem('user_data_impersonated', JSON.stringify(user));
    localStorage.setItem('TVENDO_WS_TOKEN_IMPERSONATED', accessToken);

    window.location.href = "/admin/dashboard/";
  }
}

async function wsLogout() {
  await deleteToken();
}

async function wsSaveRow(model, data, id = false) {
  return id !== false ? wsCreate(model, data) : wsUpdate(model, id, data);
}

async function wsSaveContent(model, content, notifier) {
  try {
    let res = await wsSaveRow(model, content.data, content.id);
    notifier(res.message ?? 'Actualizado', !res.success ? 'error' : 'info');
    return res.success;
  } catch (e) {
    notifier(e, 'error');
    return false;
  }
}

async function catchError(remoteError) {
  try {
    if (!remoteError.response) {
      // network error
      return { success: false, message: 'Network Error', data: [] };
    } else {
      if (remoteError.response.status == 401) {
        window.location = loginPath;
        return;
      }
      if (
        remoteError.response.data.data != null &&
        !Array.isArray(remoteError.response.data.data)
      ) {
        if (remoteError.response.data.message.includes('validación')) {
          let msg = 'Error de validación ' + '\n';
          for (let key in remoteError.response.data.data) {
            if (remoteError.response.data.data) {
              msg += remoteError.response.data.data[key][0] + '\n';
            }
          }

          return {
            success: false,
            message: msg,
            data: remoteError.response.data.data,
          };
        }
      }
      return {
        ...remoteError.response.data,
        success: false,
        message: remoteError.response.data.message,
        data: remoteError.response.data.data,
      };
    }
  } catch (error) {
    return { success: false, message: 'Error desconocido', data: [] };
  }
}

/**
 * @see https://stackoverflow.com/a/42280209/11493072
 * @see https://developer.mozilla.org/es/docs/Web/API/URL/createObjectURL
 * @see https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
 */
async function wsGetPdf(iframeId, url, errorCallback = undefined) {
  try {
    url = `${endPoint}/${apiVersion}/${url}`;
    const response = await Axios.get(url, {
      responseType: 'blob',
    });

    let iframe = document.querySelector(iframeId);

    const file = new File(
      [
        new Blob([response.data], {
          type: 'application/pdf',
        }),
      ],
      'file.pdf',
      {
        type: 'application/pdf',
      },
    );

    let objtectUrl = URL.createObjectURL(file);
    iframe.src = objtectUrl;
  } catch (ex) {
    if (errorCallback !== undefined) {
      errorCallback(ex);
      return;
    }
    if (ex.response.status === 404) {
      alert('No se encontró el pdf');
      console.error(ex.response);
    }
  }
}

async function wsGetPdfPromise(url) {
  return new Promise(async (resolve, reject) => {
    try {
      url = `${endPoint}/${apiVersion}/${url}`;
      const response = await Axios.get(url, { responseType: 'blob' });

      const file = new File(
        [
          new Blob([response.data], { type: 'application/pdf' }),
        ],
        'file.pdf',
        { type: 'application/pdf' }
      );

      let objectUrl = URL.createObjectURL(file);
      resolve(objectUrl);
    } catch (ex) {
      reject(ex);
    }
  });
}

async function wsGetFile(iframe, url, errorCallback = undefined, type = 'xml') {
  try {
    url = `${endPoint}/${apiVersion}/${url}`;
    const response = await Axios.get(url, {
      responseType: 'blob',
    });

    let objtectUrl = URL.createObjectURL(new Blob([response.data]), `file.${type}`);
    iframe.src = objtectUrl;
    URL.revokeObjectURL(objtectUrl);
  } catch (ex) {
    if (errorCallback !== undefined) {
      errorCallback(ex);
      return;
    }

    if (ex.response.status === 404) {
      alert('No se encontró el archivo');
      console.error(ex.response);
    }
  }
}

async function wsDownload(entity, fileName = undefined) {
  try {
    entity = getUrl(entity);
    let res = await Axios.get(entity, {
      responseType: 'blob',
    });
    // Asignando nombre del archivo enviado por backend
    // Ojo que tiene que estar el header Access-Control-Expose-Headers para que funcione
    const contentDisposition = res.headers['content-disposition'];
    if (contentDisposition) {
      const match = contentDisposition.match(/filename=([^;]+)/);
      if (match) {
        fileName = match[1].trim();
      }
    }
    if (fileName === undefined) {
      fileName = 'archivo';
    }

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  } catch (ex) {
    if (ex.response !== undefined) {
      ex.response.data = JSON.parse(await ex.response.data.text());
    }
    throw ex;
  }
}

export {
  wsInit,
  wsGet,
  wsGetAll,
  wsCreate,
  wsPost,
  wsUpdate,
  wsUpdateMasive,
  wsUrl,
  wsFindBy,
  wsRemove,
  wsRemoveAll,
  wsSaveRow,
  wsSaveContent,
  setToken,
  getToken,
  getLocalToken,
  wsLogout,
  wsLogin,
  wsImpersonate,
  isImpersonated,
  getCurrentUser,
  wsGetPdf,
  wsGetPdfPromise,
  wsGetFile,
  wsDownload,
};
